import { render, staticRenderFns } from "./RdpGatewayClients.vue?vue&type=template&id=2efb06c4"
import script from "./RdpGatewayClients.vue?vue&type=script&lang=js"
export * from "./RdpGatewayClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports